export const faqsPl = [
  {
    q: "Co obejmuje „system IoT na zamówienie”?",
    a: "Zazwyczaj urządzenie (lub integrację z istniejącym hardware), firmware, backend/API, aplikację mobilną lub webową oraz dashboard do monitoringu. Zakres dopasowujemy do etapu — od PoC po produkt komercyjny.",
  },
  {
    q: "Czy możecie zacząć od PoC na 2–3 miesiące?",
    a: "Tak. Wiele leadów zaczyna się od NDA i krótkiego PoC łączności albo MVP urządzenia z panelem. Budujemy wąski, mierzalny zakres, żeby zweryfikować technologię przed większą inwestycją.",
  },
  {
    q: "Czy budujecie też panel / dashboard IoT?",
    a: "Tak. Klienci rzadko chcą sam „czujnik bez widoku danych” — dashboard z wykresami, alertami i zarządzaniem urządzeniami jest częścią typowego systemu IoT na zamówienie.",
  },
  {
    q: "Na jakiej infrastrukturze chmurowej pracujecie?",
    a: "Najczęściej AWS lub rozwiązania self-hosted w UE, zależnie od wymagań RODO i kosztów. Projektujemy architekturę pod skalę floty urządzeń, nie pod jedną demo-instancję.",
  },
  {
    q: "Czy obsługujecie urządzenia od producenta OEM/ODM?",
    a: "Tak — integrujemy firmware i aplikację z hardware od OEM (w tym z Azji), porządkujemy protokół komunikacji i budujemy warstwę software pod własną markę klienta.",
  },
  {
    q: "Ile kosztuje system IoT na zamówienie?",
    a: "Prosty PoC zaczyna się zwykle od kilkudziesięciu–kilkuset tysięcy złotych. Pełna platforma z urządzeniem, aplikacją i cloudem to często setki tysięcy do kilku milionów zł — zależnie od skali. Szczegóły w artykule o kosztach urządzenia IoT.",
  },
  {
    q: "Czy utrzymujecie system po wdrożeniu?",
    a: "Tak. Oferujemy utrzymanie firmware, backendu, monitoringu floty i kolejne iteracje produktowe po premierze.",
  },
  {
    q: "Czym różni się to od osobnego zlecenia na appkę i osobnego na firmware?",
    a: "Jednym zespołem i jedną odpowiedzialnością za integrację. W leadach problemy najczęściej wychodzą na styku warstw — dlatego system IoT budujemy end-to-end.",
  },
] as const;
